// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"373":"729a539b","483":"43a041d7","538":"263c4ddd","983":"44bffc9d"}[chunkId] + ".chunk.js";
};